import { Component } from "@angular/core";
import {
  trigger,
  transition,
  style,
  animate,
  state,
} from "@angular/animations";
import { slideToLeftTransition } from "../../animations";
import { WindowService } from "@app/services/window.service";
import { AfterViewInit } from "@angular/core";
import { UserService } from "@app/services/user.service";

@Component({
  templateUrl: "./products.component.html",
  animations: [
    trigger("appFromLeftTransition", [
      state("false", style({ opacity: 0, left: "-5%" })),
      state("true", style({ opacity: 1, left: 0 })),
      transition("false => true", animate("200ms ease-in")),
    ]),
    trigger("appFromRightTransition", [
      state("false", style({ opacity: 0, right: "-5%" })),
      state("true", style({ opacity: 1, right: 0 })),
      transition("false => true", animate("200ms ease-in")),
    ]),
  ],
})
export class ProductsComponent implements AfterViewInit {
  isLoaded: boolean = false;
  hasExpired: boolean = false;
  hasAccessToCatalogBuilder: boolean = false;
  hasAccessToGIFMaker: boolean = false;

  constructor(
    private userService: UserService,
    private windowService: WindowService
  ) {
    this.userService.hasAccess("catalog-builder").then((hasAccess) => {
      this.hasAccessToCatalogBuilder = hasAccess;
    });
    this.userService.hasAccess("gif-maker").then((hasAccess) => {
      this.hasAccessToGIFMaker = hasAccess;
    });
  }

  goToUpgrade() {
    this.windowService.getNativeWindow().document.location.href =
      "/auth/redirect-to-foldsquare?next=/pricing";
  }

  goToClasses() {
    this.windowService.getNativeWindow().document.location.href =
      "/e-commerce-classes";
  }

  // change the animation state
  getState(outlet) {
    return outlet.activatedRouteData.state;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.isLoaded = true;
    }, 1000);
    this.userService
      .hasExpired()
      .then((hasExpired) => (this.hasExpired = hasExpired));
  }
}
